module.exports = __webpack_public_path__ + "img/ADDRESS.44304b05.svg";